import 'core-js';
import 'custom-event-polyfill';
import 'intl';
import 'intl/locale-data/jsonp/en.js';
import 'matchmedia-polyfill';
import 'matchmedia-polyfill/matchMedia.addListener';

require('./bootstrap');

import { Calendar } from 'v-calendar';
import MenuSearch from './components/MenuSearch.vue';
import SidebarSearch from './components/SidebarSearch.vue';
import MobileMenu from './components/mobile-menu';
import LaserSlider from './components/LaserSlider';
import CarouselSquares from './components/CarouselSquares';
import CarouselQuotes from './components/CarouselQuotes';
import Collapsable from './components/Collapsable';
import CollapsableRestyled from './components/CollapseableRestyled';
import YouTubeModal from './components/YouTubeModal';
import ContactForm from './components/ContactForm';
import LightBox from './components/LightBox';
import SwipeGallery from './components/SwipeGallery';
import EventCalendar from './components/EventCalendar';
import 'owl.carousel';

require('./giles-ui/Nudge/index');
require('./giles-ui/ScrollTo/index');
require('./giles-ui/Ziggy/index');

Vue.component('spoiler', 'giles-ui/Spoiler/index.vue');
Vue.component('menu-search', MenuSearch);
Vue.component('sidebar-search', SidebarSearch);
Vue.component('collapsable', Collapsable);
Vue.component('collapsable-restyled', CollapsableRestyled);
Vue.component('laser-slider', LaserSlider);
Vue.component('carousel-squares', CarouselSquares);
Vue.component('carousel-quotes', CarouselQuotes);
Vue.component('youtube-modal', YouTubeModal);
Vue.component('contact-form', ContactForm);
Vue.component('light-box', LightBox);
Vue.component('swipe-gallery', SwipeGallery);
Vue.component('event-calendar', EventCalendar);

// const revolutionScriptsToMove = jQuery('.rev_slider_wrapper')
//     .find('script')
//     .detach();

if (document.getElementById('app')) {
    new Vue({
        el: '#app',
        mounted() {

            new MobileMenu;

            require('./components/data-background');
            require('./components/intercom');
            require('./components/google-map-scroll-hack');
            require('./components/page-index');
            require('./giles-ui/ResponsiveIframe/index');
        },
    });
}

jQuery(document).ready(function() {
    jQuery('.owl-carousel').owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        dots: true,
        touchDrag: false,
        mouseDrag: false,
        responsive: {
            0: {
                items: 1,
            },
        },
        animateOut: 'fadeOut',
        autoplayTimeout: 5000,
    });
    function setHeaderHeight() {
        let height = jQuery('#fixed-header').outerHeight();
        if (window.innerWidth < 768) {
            height = 0;
        }
        jQuery('body').css("margin-top",height+'px');
    }
    setHeaderHeight();
    jQuery( window ).resize(function() {
        setHeaderHeight();
    });


    setInterval(function(){
        jQuery('.recruit-descriptions').each(function() {
            let cur = jQuery(this).find('.current').removeClass('current');
            cur.hide()
            let next = cur.next().length ? cur.next() : jQuery(this).children().eq(0);
            next.show()
            next.addClass('current');

        });
    },3000);

    jQuery('.VueCarousel-inner').attr('aria-label', 'Carousel Container');
    jQuery('.slides li a').attr('aria-label', 'Carousel Slide Link')
});

// revolutionScriptsToMove
//     .append(jQuery('#rev-script-zone'));


document.addEventListener("DOMContentLoaded", function() {
    // Find all elements with role="listbox"
    var listboxes = document.querySelectorAll('[role="listbox"]');

    // Iterate through each listbox
    listboxes.forEach(function(listbox) {
        // Get all children of the listbox
        var children = listbox.children;

        // Iterate through each child
        for (var i = 0; i < children.length; i++) {
            var child = children[i];

            // Check if the child has role="option"
            if (child.getAttribute('role') !== 'option') {
                // Assign role="option" to the child
                child.setAttribute('role', 'option');
            }
        }
    });
});



// WEBPACK FOOTER //
// ./web/app/themes/giles/resources/js/app.js